<script setup lang="ts"></script>

<template>
  <NovaLayoutWrapper>
    <NovaHeader />
    <NovaLayoutDefault>
      <template #center>
        <slot />
      </template>
    </NovaLayoutDefault>
  </NovaLayoutWrapper>
</template>
